// Add your custom JS here.

// hero-slider

$('.hero-text-slider').slick({
    vertical: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 300
});